export interface PhotoObject {
    id?: number;
    src?: string | null;
    thumbnailSrc?: string | null,
    disabled?: boolean;
    saved?: boolean;
    edited?: boolean;
}

export const InitialStoryPhotoArray: PhotoObject[] = [
    {
        src: null,
        thumbnailSrc: null,
        saved: false,
        edited: false
    },
    {
        src: null,
        thumbnailSrc: null,
        disabled: false,
        saved: false,
        edited: false
    },
    {
        src: null,
        thumbnailSrc: null,
        disabled: true,
        saved: false,
        edited: false
    },
    {
        src: null,
        thumbnailSrc: null,
        disabled: true,
        saved: false,
        edited: false
    },
    {
        src: null,
        thumbnailSrc: null,
        disabled: true,
        saved: false,
        edited: false
    }
]